import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import navLocaleData from '@99designs/globalnav/locale-data/en';
import { setTranslations as setNavTranslations } from '@99designs/globalnav/locale-data';

setNavTranslations(navLocaleData);
addLocaleData(en);



// WEBPACK FOOTER //
// ./src/js/locale-data/en.js